/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */
define('pdfGear/generator/components',[], function() {
    'use strict';

    return {
        getHorizontalLine: getHorizontalLine,
        getPageBreakElement: getPageBreakElement,
    };

    /**
     * Funtion to draw a horizontal line on a pdf using pdfmake library
     * @param  margin array contains the margins that has to be around the line
     * @return array of javascript objects
     */
    function getHorizontalLine(marginArray) {
        return {
            table: {
                widths: [550],
                body: [
                    [''],
                    ['']
                ]
            },
            margin: marginArray,
            layout: {
                hLineWidth: function(i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0 : 1;
                },
                vLineWidth: function() {
                    return 0;
                },
                hLineColor: function() {
                    return '#78a5c8';
                }
            }
        };
    }
    /**
     * Function to add a page break in pdf page
     * return array of element containing blank text and pagebreak
     */
    function getPageBreakElement() {
        return [{
            text: '',
            pageBreak: 'after'
        }];
    }
});
